var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['material-icons', 'icon-button', ("md-" + (_vm.size ? _vm.size : '24'))],on:{"click":function($event){return _vm.toggleTheme()}}},[_vm._v(_vm._s(_vm.dark_mode ? "wb_sunny" : "brightness_4"))])}
var staticRenderFns = []

export { render, staticRenderFns }